import {SignUpView} from "../views/SignUpView.tsx";
import {AuthLayout} from "../layouts/AuthLayout.tsx";

export const SignUpPage = () => {
    return (
        <AuthLayout showWelcomePanel>
            <SignUpView />
        </AuthLayout>
    )
}
